import { IWsSentryLogRow } from "../../WSUtils/wsSentry";
import { BackendResponse } from "../BackendResponse";

export interface LogErrorsResponse extends BackendResponse {
  items: string[];
}

export interface LogErrorsParameters {
  konsernid: number;
  logitems: IWsSentryLogRow[];
}

export type logErrors = (
  args: LogErrorsParameters
) => Promise<LogErrorsResponse>;

export const logErrors: logErrors = (args) => {
  throw new Error("not implemented");
};
